"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_CONFIG = exports.AUTH_PREFIX_PATH = exports.APP_PREFIX_PATH = exports.API_BASE_URL = exports.APP_NAME = void 0;

var _ThemeConstant = require("../constants/ThemeConstant");

var _EnvironmentConfig = require("./EnvironmentConfig");

var APP_NAME = 'Emilus';
exports.APP_NAME = APP_NAME;
var API_BASE_URL = _EnvironmentConfig.env.API_ENDPOINT_URL;
exports.API_BASE_URL = API_BASE_URL;
var APP_PREFIX_PATH = '/clPortal/app';
exports.APP_PREFIX_PATH = APP_PREFIX_PATH;
var AUTH_PREFIX_PATH = '/clPortal/auth';
exports.AUTH_PREFIX_PATH = AUTH_PREFIX_PATH;
var THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: _ThemeConstant.SIDE_NAV_LIGHT,
  locale: 'en',
  navType: _ThemeConstant.NAV_TYPE_SIDE,
  topNavColor: '#3e82f7',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: 'light'
};
exports.THEME_CONFIG = THEME_CONFIG;